// Timeline de eventos do contrato (07/out/2026) — funções PURAS usadas pelo
// modal de Eventos e pelo modal Ativar contrato.

// Cores por tipo. Classes completas (o Tailwind só gera o que aparece no código).
export const CORES_EVENTO = {
    homologacao: {
        ponto: 'bg-sky-500', anel: 'ring-sky-200 dark:ring-sky-900',
        texto: 'text-sky-700 dark:text-sky-300',
        chip: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
    },
    reajuste: {
        ponto: 'bg-blue-600', anel: 'ring-blue-200 dark:ring-blue-900',
        texto: 'text-blue-700 dark:text-blue-300',
        chip: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
        botao: 'border-blue-200 bg-blue-50 text-blue-800 hover:bg-blue-100 hover:border-blue-300 dark:border-blue-900 dark:bg-blue-950/40 dark:text-blue-200 dark:hover:bg-blue-900/50',
        botaoAtivo: 'border-blue-600 bg-blue-600 text-white dark:border-blue-500 dark:bg-blue-600',
    },
    aditivo: {
        ponto: 'bg-green-600', anel: 'ring-green-200 dark:ring-green-900',
        texto: 'text-green-700 dark:text-green-300',
        chip: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
        botao: 'border-green-200 bg-green-50 text-green-800 hover:bg-green-100 hover:border-green-300 dark:border-green-900 dark:bg-green-950/40 dark:text-green-200 dark:hover:bg-green-900/50',
        botaoAtivo: 'border-green-600 bg-green-600 text-white dark:border-green-500 dark:bg-green-600',
    },
    supressao: {
        ponto: 'bg-red-600', anel: 'ring-red-200 dark:ring-red-900',
        texto: 'text-red-700 dark:text-red-300',
        chip: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
        botao: 'border-red-200 bg-red-50 text-red-800 hover:bg-red-100 hover:border-red-300 dark:border-red-900 dark:bg-red-950/40 dark:text-red-200 dark:hover:bg-red-900/50',
        botaoAtivo: 'border-red-600 bg-red-600 text-white dark:border-red-500 dark:bg-red-600',
    },
    renovacao: {
        ponto: 'bg-purple-600', anel: 'ring-purple-200 dark:ring-purple-900',
        texto: 'text-purple-700 dark:text-purple-300',
        chip: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200',
        botao: 'border-purple-200 bg-purple-50 text-purple-800 hover:bg-purple-100 hover:border-purple-300 dark:border-purple-900 dark:bg-purple-950/40 dark:text-purple-200 dark:hover:bg-purple-900/50',
        botaoAtivo: 'border-purple-600 bg-purple-600 text-white dark:border-purple-500 dark:bg-purple-600',
    },
    // Cancelamento e sua reversão (spec 2026-10-27).
    cancelamento: {
        ponto: 'bg-zinc-700 dark:bg-zinc-400', anel: 'ring-zinc-200 dark:ring-zinc-700',
        texto: 'text-zinc-800 dark:text-zinc-200',
        chip: 'bg-zinc-200 text-zinc-800 dark:bg-zinc-700 dark:text-zinc-100',
        botao: 'border-zinc-300 bg-zinc-50 text-zinc-800 hover:bg-zinc-100 hover:border-zinc-400 dark:border-zinc-600 dark:bg-zinc-800/60 dark:text-zinc-100 dark:hover:bg-zinc-700',
        botaoAtivo: 'border-zinc-700 bg-zinc-700 text-white dark:border-zinc-500 dark:bg-zinc-600',
    },
    reativacao: {
        ponto: 'bg-teal-600', anel: 'ring-teal-200 dark:ring-teal-900',
        texto: 'text-teal-700 dark:text-teal-300',
        chip: 'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-200',
    },
    cadastro: {
        ponto: 'bg-gray-400 dark:bg-gray-500', anel: 'ring-gray-200 dark:ring-gray-700',
        texto: 'text-gray-600 dark:text-gray-300',
        chip: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
    },
};

export const MOTIVO_PADRAO_ATIVACAO = 'Ativação do contrato';
const TITULO_TIPO = { reajuste: 'Reajuste', aditivo: 'Aditivo', supressao: 'Supressão', renovacao: 'Renovação de vigência', cancelamento: 'Cancelamento', reativacao: 'Cancelamento revertido' };
const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

const pad2 = (n) => String(n).padStart(2, '0');
const RE_TEXTO_MYSQL = /^(\d{4})-(\d{2})-(\d{2})(?:[ ]\d{2}:\d{2}(?::\d{2})?)?$/;

// Data do backend → Date. Texto "YYYY-MM-DD[ HH:MM:SS]" é hora de parede (vale
// literal); ISO com "T" é um Date serializado pelo mysql2 → convertido para o
// fuso de quem está vendo (Brasília), como o resto do app faz.
const paraDate = (v) => {
    if (v == null || v === '') return null;
    if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
    const s = String(v);
    const m = s.match(RE_TEXTO_MYSQL);
    const d = m ? new Date(s.length > 10 ? s.replace(' ', 'T') : `${s}T00:00:00`) : new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
};

export const dataBR = (v) => {
    const s = v == null ? '' : String(v);
    const m = s.match(RE_TEXTO_MYSQL);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    if (!/^\d{4}-\d{2}-\d{2}T/.test(s) && !(v instanceof Date)) return '';
    const d = paraDate(v);
    return d ? `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}` : '';
};

// Data e hora "dd/mm/aaaa hh:mm" em Brasília. Texto do MySQL é hora de parede
// (vale literal); ISO/Date vai para America/Sao_Paulo.
export const dataHoraBrasilia = (v) => {
    const s = v == null ? '' : String(v);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ ](\d{2}):(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}`;
    if (!/^\d{4}-\d{2}-\d{2}T/.test(s) && !(v instanceof Date)) return '';
    const d = paraDate(v);
    if (!d) return '';
    const p = new Intl.DateTimeFormat('pt-BR', {
        timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(d);
    const g = (t) => p.find((x) => x.type === t).value;
    return `${g('day')}/${g('month')}/${g('year')} ${String(Number(g('hour')) % 24).padStart(2, '0')}:${g('minute')}`;
};

// Linha de auditoria: "lançado por X em dd/mm/aaaa hh:mm" (created_at do evento).
const lancamentoDe = (autor, criadoEm) => {
    const quando = dataHoraBrasilia(criadoEm);
    if (!autor && !quando) return null;
    return `lançado${autor ? ` por ${autor}` : ''}${quando ? ` em ${quando}` : ''}`;
};

// Coluna DATE (sem hora): os 10 primeiros caracteres valem (o servidor fica a oeste de UTC).
const dataCurtaBR = (v) => {
    const m = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

export const brl = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const temNumero = (v) => v != null && v !== '' && !Number.isNaN(Number(v));

const percentualBR = (p) => {
    const n = Number(p);
    return `${n > 0 ? '+' : ''}${n.toLocaleString('pt-BR', { maximumFractionDigits: 4 })}%`;
};

const lerDetalhe = (detalhe) => {
    if (detalhe && typeof detalhe === 'object') return detalhe;
    if (typeof detalhe !== 'string' || !detalhe.trim()) return {};
    try {
        const obj = JSON.parse(detalhe);
        return obj && typeof obj === 'object' ? obj : {};
    } catch (e) { return {}; }
};

const autorDe = (ev) => ev.user_name || (ev.user_id ? `usuário ${ev.user_id}` : null);

const tituloDe = (ev) => {
    if (ev.tipo === 'homologacao') return 'Ativação — Homologação da Instalação';
    // Renovação com reajuste (09/out/2026): prazo + percentual num lançamento só.
    if (ev.tipo === 'renovacao' && ev.modo === 'percentual' && temNumero(ev.percentual)) {
        return `Renovação com reajuste ${percentualBR(ev.percentual)}`;
    }
    if (ev.tipo === 'renovacao') return TITULO_TIPO.renovacao;
    const base = TITULO_TIPO[ev.tipo] || String(ev.tipo || 'Evento');
    // Edição manual de valor em contrato ativo, convertida em evento (09/out/2026).
    if (ev.modo === 'edicao') return `${base} — edição de valor`;
    if (temNumero(ev.percentual)) return `${base} ${percentualBR(ev.percentual)}`;
    if (temNumero(ev.valor)) return `${base} ${brl(ev.valor)}`;
    if (ev.modo === 'itens') return `${base} de itens`;
    return base;
};

const linhasDe = (ev, detalhe, autor) => {
    const linhas = [];
    const motivo = String(ev.motivo || '').trim();
    if (ev.tipo === 'homologacao') {
        const resp = typeof detalhe.responsavel_cliente === 'string' ? detalhe.responsavel_cliente.trim() : '';
        if (resp) linhas.push(`Responsável no cliente: ${resp}`);
        if (autor) linhas.push(`Responsável Vox: ${autor}`);
        if (motivo && motivo !== MOTIVO_PADRAO_ATIVACAO) linhas.push(motivo);
        return linhas;
    }
    if (ev.tipo === 'cancelamento' || ev.tipo === 'reativacao') {
        const d = ev.tipo === 'cancelamento' ? detalhe.data_cancelamento : detalhe.data_cancelamento && detalhe.data_cancelamento.de;
        if (d) linhas.push(ev.tipo === 'cancelamento' ? `Sem cobrança a partir de ${dataCurtaBR(d)}` : `Cancelamento de ${dataCurtaBR(d)} desfeito`);
        const termo = String(ev.numero_termo || '').trim();
        if (termo) linhas.push(`Termo: ${termo}`);
        if (motivo) linhas.push(motivo);
        return linhas;
    }
    if (ev.tipo === 'renovacao') {
        const nova = detalhe.vigencia && dataCurtaBR(detalhe.vigencia.para);
        if (nova) linhas.push(`Nova data fim: ${nova}`);
    }
    if ((ev.tipo !== 'renovacao' || ev.modo === 'percentual') && temNumero(ev.valor_antes) && temNumero(ev.valor_depois)) {
        linhas.push(`${brl(ev.valor_antes)} → ${brl(ev.valor_depois)}`);
    }
    const termo = String(ev.numero_termo || '').trim();
    if (termo) linhas.push(`Termo: ${termo}`);
    if (motivo) linhas.push(motivo);
    return linhas;
};

// Lista do mais recente ao mais antigo, terminando em "Contrato cadastrado".
// `fase` = situação do contrato DEPOIS do item (o trecho da linha abaixo dele
// usa a fase do item mais antigo): faturando da ativação vigente para cima.
export const montarTimeline = (eventos, contrato = {}) => {
    const lista = Array.isArray(eventos) ? eventos.filter(Boolean) : [];
    const homologacoes = lista.filter((e) => e.tipo === 'homologacao');
    const idVigente = homologacoes.length ? Math.max(...homologacoes.map((e) => Number(e.id) || 0)) : null;

    const ts = (v) => { const d = paraDate(v); return d ? d.getTime() : -Infinity; };
    const ordenados = [...lista].sort((a, b) => (ts(b.data_evento) - ts(a.data_evento)) || ((Number(b.id) || 0) - (Number(a.id) || 0)));

    const itens = ordenados.map((ev) => {
        const detalhe = lerDetalhe(ev.detalhe);
        const autor = autorDe(ev);
        const ehHomologacao = ev.tipo === 'homologacao';
        const substituida = ehHomologacao && Number(ev.id) !== idVigente;
        return {
            chave: `ev-${ev.id}`, id: ev.id, data: ev.data_evento, dataFmt: dataBR(ev.data_evento),
            tipo: ev.tipo, titulo: tituloDe(ev), cor: CORES_EVENTO[ev.tipo] || CORES_EVENTO.cadastro,
            linhas: linhasDe(ev, detalhe, autor), autor, lancamento: lancamentoDe(autor, ev.created_at),
            ehAtivacao: ehHomologacao && !substituida, substituida,
            anexoNome: ev.anexo_nome || null,
            responsavelCliente: ehHomologacao && typeof detalhe.responsavel_cliente === 'string' ? detalhe.responsavel_cliente.trim() : '',
        };
    });
    if (contrato && contrato.created_at) {
        itens.push({
            chave: 'cadastro', data: contrato.created_at, dataFmt: dataBR(contrato.created_at), tipo: 'cadastro',
            titulo: 'Contrato cadastrado', cor: CORES_EVENTO.cadastro, linhas: [], autor: null, lancamento: null,
            ehAtivacao: false, substituida: false, responsavelCliente: '',
        });
    }

    const posAtivacao = itens.findIndex((i) => i.ehAtivacao);
    const semAtivacao = contrato && contrato.status === 'implantacao' ? 'implantacao' : 'faturando';
    return itens.map((item, i) => ({
        ...item,
        fase: posAtivacao === -1 ? semAtivacao : (i <= posAtivacao ? 'faturando' : 'implantacao'),
    }));
};

const ddmm = (ymd) => `${String(ymd).slice(8, 10)}/${String(ymd).slice(5, 7)}`;

// Caixa "Primeiro faturamento" do Ativar contrato (resposta do /eventos/preview).
// Competência = mês do FIM do ciclo (mesma regra do backend).
export const resumoPrimeiroFaturamento = (previa) => {
    if (!previa || !previa.ciclo || !previa.ciclo.fim) return null;
    const ano = Number(String(previa.ciclo.fim).slice(0, 4));
    const mes = Number(String(previa.ciclo.fim).slice(5, 7));
    const nome = MESES[mes - 1] || '';
    const competencia = `${nome.charAt(0).toUpperCase()}${nome.slice(1)}/${ano}`;
    const seguinte = mes === 12 ? `${MESES[0]}/${ano + 1}` : `${MESES[mes]}/${ano}`;
    const diasCobrados = Number(previa.dias_cobrados) || 0;
    const diasCiclo = Number(previa.ciclo.dias) || 0;
    const mensal = Number(previa.valor_antes) || 0;
    const proporcional = Number(previa.proporcional) || 0;
    return {
        competencia, seguinte, diasCobrados, diasCiclo, mensal, proporcional,
        inicio: ddmm(previa.ciclo.inicio), fim: ddmm(previa.ciclo.fim),
        ativacao: previa.inicio_cobranca ? ddmm(previa.inicio_cobranca) : '',
        fracao: diasCiclo ? Math.min(1, Math.max(0, diasCobrados / diasCiclo)) : 0,
        linhaProporcional: `${competencia}: ${diasCobrados} de ${diasCiclo} dias × ${brl(mensal)} = ${brl(proporcional)}`,
        linhaSeguinte: `a partir de ${seguinte}: ${brl(mensal)} por mês`,
    };
};

// "Hoje" em Brasília (YYYY-MM-DD) — limite do campo de data da ativação.
export const hojeBrasilia = (agora = new Date()) => {
    const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(agora);
    const g = (t) => p.find((x) => x.type === t).value;
    return `${g('year')}-${g('month')}-${g('day')}`;
};
